import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.keys.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { tableConfig } from './components/config.js';
import { getLogList, getSalaryNotice, repealSalaryDate as _repealSalaryDate } from '@/api/payroll';
import ChangeSalary from './modal/change-salary';
export default {
  components: {
    ChangeSalary: ChangeSalary
  },
  data: function data() {
    return {
      tableData: {
        list: [],
        columns: {},
        staffInfo: {}
      },
      pageSizes: [20, 50, 100],
      staff_id: this.$route.params.staff_id,
      settlement_type: '1',
      page: {
        currPage: 1,
        limit: 20,
        total: 100
      },
      year: new Date().getFullYear().toString()
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return this.contentViewHeight - 130;
    }
  }),
  created: function created() {
    this.init(1);
  },
  methods: {
    init: function init(page) {
      var _this = this;
      this.page.currPage = page;
      // 调薪纪录
      this.tableData = {
        list: [],
        columns: {},
        staffInfo: {}
      };
      getLogList({
        staff_info_id: this.staff_id
        // page_size: this.page.limit,
        // page
      }).then(function (res) {
        if (res.data) {
          _this.tableData.staffInfo = res.data.staff_info || {};
          _this.tableData.list = res.data.list || [];
          _this.tableData.columns = _this.handleColumn(res.data.columns || {});
        }
        _this.$nextTick(function () {
          if (_this.$refs.table) _this.$refs.table.doLayout();
        });
      });
    },
    // 处理表头数据
    handleColumn: function handleColumn(columns) {
      var arr = [];
      tableConfig.forEach(function (item) {
        if (columns[item.prop]) {
          arr.push(item);
          delete columns[item.prop];
        }
      });
      if (Array.isArray(columns)) return;
      var keys = Object.keys(columns);
      keys.forEach(function (item) {
        arr.push({
          edit: false,
          type: '',
          label: columns[item],
          prop: item,
          width: 200
        });
      });
      return arr;
    },
    // 编辑or查看
    handleEdit: function handleEdit(row, status) {
      this.$set(row, 'statusEdit', status);
      this.$refs.changeSalary.init(row);
    },
    // 撤销
    handleRevoke: function handleRevoke(row) {
      var _this2 = this;
      getSalaryNotice({
        staff_info_id: this.staff_id,
        salary_update_start_date: row.update_start_date
      }).then(function (res) {
        if (res.data && res.data.is_show) {
          _this2.$confirm(_this2.$t('i18n.c219790c6b4f4d07b4a8d59ec8250b61'), _this2.$t('i18n.3c395f46dbef4318872c345723b60426'), {
            confirmButtonText: _this2.$t('131'),
            cancelButtonText: _this2.$t('66'),
            type: 'warning'
          }).then(function () {
            _this2.repealSalaryDate(row);
          }).catch(function () {});
        } else {
          _this2.repealSalaryDate(row);
        }
      });
    },
    repealSalaryDate: function repealSalaryDate(row) {
      var _this3 = this;
      _repealSalaryDate({
        id: row.id,
        staff_info_id: this.staff_id
      }).then(function () {
        _this3.init(1);
      });
    },
    handlerBack: function handlerBack() {
      this.$router.go(-1);
    },
    // 查看文件
    onClick: function onClick(url) {
      window.open(url);
    } // handleSizeChange(val) {
    //   this.page.limit = val
    //   this.init(1)
    // },
    // handleCurrentChange(val) {
    //   this.init(val)
    // },
  }
};